

















import Vue from 'vue';
import axios from 'axios';

export default Vue.extend({
    name: 'ResetPassword',
    data() {
        return {
            email: '',
            password: '',
            tokenError: '',
            submitError: '',
            disableButton: false
        }
    },
    created() {
        this.$store.state.routeLoaded = true;
        axios.get(this.$store.state.apiUrl + '/auth/reset-password/' + this.$route.params.token)
            .then(resp => {
                this.email = resp.data.email;
            })
            .catch(e => {
                this.tokenError = e.response ? e.response.data : 'That link is invalid or has expired.';
            });
    },
    methods: {
        submit() {
            if(this.disableButton) return;
            this.disableButton = true;
            this.submitError = '';
            axios.post(this.$store.state.apiUrl + '/auth/reset-password', {
                token: this.$route.params.token,
                password: this.password
            })
                .then(() => {
                    this.disableButton = false;
                    (this.$parent as any).checkSession();
                    this.$router.push('/');
                })
                .catch(e => {
                    this.disableButton = false;
                    this.submitError = e.response ? e.response.data : 'There was an error resetting your password.';
                });
        }
    }
})
